import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slices/authSlice";
import dashboardReducer from "./slices/dashboardSlice";
import filtersReducer from "./slices/filtersSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    filters: filtersReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
